(() => {
  const FORM_SELECTOR = '[data-guest-submission-form]';
  const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again or email editor@katebackdrop.com.';

  const showResult = (form, type, message) => {
    const result = form.querySelector('[data-guest-submission-result]');
    const content = form.querySelector('[data-guest-submission-result-content]');

    if (!result || !content) {
      return;
    }

    result.classList.toggle('banner--success', type === 'success');
    result.classList.toggle('banner--error', type === 'error');
    content.textContent = message;
    result.hidden = false;
  };

  const hideResult = (form) => {
    const result = form.querySelector('[data-guest-submission-result]');

    if (result) {
      result.hidden = true;
    }
  };

  const buildPayload = (form) => ({
    name: form.querySelector('#contact-form-name')?.value.trim() || '',
    email: form.querySelector('#contact-form-email')?.value.trim() || '',
    message: form.querySelector('#contact-form-message')?.value.trim() || '',
    customFields: Array.from(form.querySelectorAll('[data-guest-custom-field]')).map((field) => ({
      label: field.dataset.fieldLabel || '',
      value: field.value.trim(),
    })),
    website: form.elements.website?.value || '',
  });

  const clearForm = (form) => {
    form.reset();
    form
      .querySelectorAll('#contact-form-name, #contact-form-email, #contact-form-message, [data-guest-custom-field], [name="website"]')
      .forEach((field) => {
        field.value = '';
      });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    if (!form.reportValidity()) {
      return;
    }

    const submitButton = form.querySelector('[type="submit"]');
    const originalButtonText = submitButton?.textContent;
    hideResult(form);
    form.setAttribute('aria-busy', 'true');

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Sending...';
    }

    try {
      const response = await fetch(form.dataset.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(buildPayload(form)),
      });

      const responseBody = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error('Submission failed');
      }

      clearForm(form);
      showResult(form, 'success', responseBody.message || form.dataset.successMessage);
    } catch (error) {
      showResult(form, 'error', DEFAULT_ERROR_MESSAGE);
    } finally {
      form.removeAttribute('aria-busy');

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
      }
    }
  };

  const initializeForms = (scope = document) => {
    const forms = scope.matches?.(FORM_SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll(FORM_SELECTOR));

    forms.forEach((form) => {
      if (form.dataset.guestSubmissionInitialized === 'true') {
        return;
      }

      form.dataset.guestSubmissionInitialized = 'true';
      form.addEventListener('submit', handleSubmit);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeForms());
  } else {
    initializeForms();
  }

  document.addEventListener('shopify:section:load', (event) => initializeForms(event.target));
})();
